var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextboxWidgetIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13818",
    d: "M428.32 120.015a2.413 2.413 0 0 0-2.414-2.414h-3.1v2.069h3.1a.345.345 0 0 1 .345.345v3.1h2.069z",
    transform: "translate(-408.32 -117.601)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13819",
    d: "M428.32 355.905v-3.1h-2.069v3.1a.345.345 0 0 1-.345.345h-3.1v2.069h3.1a2.413 2.413 0 0 0 2.414-2.414z",
    transform: "translate(-408.319 -338.319)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13820",
    d: "M187.6 355.9a2.414 2.414 0 0 0 2.414 2.414h3.1v-2.064h-3.1a.345.345 0 0 1-.345-.345v-3.1H187.6z",
    transform: "translate(-187.599 -338.319)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13821",
    d: "M187.6 123.119h2.069v-3.1a.345.345 0 0 1 .345-.345h3.1V117.6h-3.1a2.413 2.413 0 0 0-2.414 2.414z",
    transform: "translate(-187.6 -117.602)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13822",
    d: "M282.717 216.853v-7.586h3.448V207.2H277.2v2.069h3.448v7.586z",
    transform: "translate(-271.682 -201.681)",
    style: {
      fill: "#333"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextboxWidgetIcon);
export default __webpack_public_path__ + "static/media/textbox-widget-icon.64f20c68458370a66a33e7c5d3a0c6e0.svg";
export { ForwardRef as ReactComponent };